module.exports = __webpack_public_path__ + "img/dispersion.bcaa1ffe.svg";